import React from 'react'
import {
    Form,
  Input,
  TextArea,
  Toast,
  Button,ImageUploader,Ellipsis,List,Picker,Modal,Dialog,NavBar,Image,Selector,Grid,FloatingBubble,Popup,Space
} from 'antd-mobile-v5';
import dayjs from 'dayjs'
import { ExclamationCircleFill } from 'antd-mobile-icons'

import BottomMenu from '../../comronent/BottomMenu/index';
import '../../assets/font/font.css'

import '../MsgAdd/index.css'
import { useNavigate,useParams,useLocation } from 'react-router-dom';
import { environment } from '../../service/baseUrl';
import {
    GetMediasById, PostUserAction,SaveUserAction,DelMediasById
  } from '../../service/service';

const withNavigate = (WrappedComponent) => {
    return (props) => {
        const params = useParams();
        const navigate = useNavigate();
        const location = useLocation();
        return <WrappedComponent {...props} params={params} navigate={navigate} location={location} />;
    };
};

class Index extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            id: 0,
            planetId: 0,
            fileList: [],
            videoInfo: {},
            userInfo: {},

            textArea: "",
            userAction: [],
            pId: null,
            pUserName: "",

            visible: false,
        };
    }

    componentDidMount() {
        var that = this;

        const { location } = this.props;
        const { planetId, id } = location.state || {}; // 获取 URL 参数
        this.setState({
            planetId: planetId,
            id: id,
        }, () => {
            this.loadUserAction()
        })

        if (id) {
            GetMediasById(id).then(res => {
                if (res.success) {
                    var result = res.result;
                    result.fileUrl = environment.apiEndpoint + "/NNFiles/Video/" + result.fileUrl;

                    that.setState({
                        id: id,
                        imgName: result.headImg,
                        videoInfo: result,
                    })
                }
            })
        }

        var user = localStorage.getItem("user");
        if (user == null || user == undefined) {
            return;
        }

        this.setState({
            userInfo: JSON.parse(user)
        })

    }
    
    loadUserAction = () => {
        var that = this;
        var data = {
            TableType: "Media",
            TableId: this.state.id,
            Type: 1,
        };
        PostUserAction(data).then(res => {
            if (res.success) {
                res.result.map(item => {
                    // item.headImg = environment.apiEndpoint + "/NNFiles/Img/" + item.headImg;
                    if (item.headImg != null) {
                        if (item.headImg.indexOf("https://") > -1) {
                            var urls = item.headImg.split("https://").filter(Boolean);
                            item.headImg = urls.length > 0 ? `https://${urls[urls.length - 1]}` : "";
                        } else {
                            item.headImg = environment.apiEndpoint + "/NNFiles/Img/" + item.headImg;
                        }
                    }

                    const creationTime = new Date(item.creationTime); 
                    item.creationTime = that.formatTimeDifference(creationTime);

                    var cUserActionDto = item.cUserActionDto;
                    item.zanCount = item.cUserActionDto.filter(action => action.type === 2).length;
                    item.yanCount = item.cUserActionDto.filter(action => action.type === 1).length;
                    item.cUserActionDto = cUserActionDto.filter(action => action.type === 1);
                    item.yanList = cUserActionDto.filter(action => action.type === 2);
                })
                that.setState({
                    userAction: res.result
                })
            }
        })
    }

    formatTimeDifference(creationTime) {
        const now = new Date();
        const timeDiff = now - creationTime; // 时间差（毫秒）
        const diffInSec = Math.floor(timeDiff / 1000);
        const diffInMin = Math.floor(diffInSec / 60);
        const diffInHours = Math.floor(diffInMin / 60);
        const diffInDays = Math.floor(diffInHours / 24);

        if (diffInSec < 60) {
            return "刚刚";
        } else if (diffInMin < 60) {
            return `${diffInMin}分钟前`;
        } else if (diffInHours < 24) {
            return `${Math.max(1, diffInHours)}小时前`; // 不足1小时显示"1小时前"
        } else if (diffInDays < 3) {
            return `${diffInDays}天前`;
        } else {
            // 超过3天显示具体日期（如 "2023-05-15"）
            return new Date(Date.now() - timeDiff).toLocaleDateString("zh-CN");
        }
    }


    submitForm = (data) => {
        var that = this;
        SaveUserAction(data).then(res => {
            if (res.success) {
                that.setState({
                    visible: false,
                    textArea: "",
                    pUserName: "",
                    pId: null,
                })
                that.loadUserAction();
            }
        })
    }

    render() {
        const showDialog = () => {
            Dialog.show({
                title: (
                    <div style={{
                        textAlign: 'center',
                        fontSize: 18,
                        color: '#595959',
                        padding: '8px 0',
                        marginTop: "25px",
                        fontFamily: '"STKaiti", "KaiTi", serif' // 楷体字体
                    }}>
                        <ExclamationCircleFill style={{
                            color: '#ff4d4f',
                            fontSize: 24,
                            marginRight: 8
                        }} />
                        确认删除此视频？
                </div>
                ),
                content: (
                    <div style={{
                        textAlign: 'center',
                        color: '#8c8c8c',
                        padding: '12px 0 16px',
                        fontSize: 14,
                        paddingBottom: "10px",
                        paddingTop: "0px",
                        fontFamily: '"STKaiti", "KaiTi", serif'
                    }}>
                        删除后将无法恢复
                </div>
                ),
                actions: [
                    [
                        {
                            key: 'cancel',
                            text: (
                                <span style={{
                                    display: 'inline-block',
                                    width: '100%',
                                    color: '#8c8c8c',
                                    fontSize: 16,
                                    letterSpacing: 2,
                                    fontFamily: '"STKaiti", "KaiTi", serif'
                                }}>
                                    取 消
                      </span>
                            ),
                            style: {
                                borderRight: '1px solid #f0f0f0'
                            },
                            onClick: () => {
                                console.log('回忆已随风消散...')
                                Dialog.clear()
                            }
                        },
                        {
                            key: 'delete',
                            text: (
                                <span style={{
                                    display: 'inline-block',
                                    width: '100%',
                                    color: '#ff4d4f',
                                    fontSize: 16,
                                    letterSpacing: 2,
                                    fontWeight: 'bold',
                                    fontFamily: '"STKaiti", "KaiTi", serif'
                                }}>
                                    删 除
                      </span>
                            ),
                            onClick: () => {
                                var that = this;

                                DelMediasById(that.state.videoInfo.id).then(res => {
                                    if (res.success) {
                                        if(res.result){
                                            that.props.navigate('/videos', {
                                                replace: true,
                                                state: { id: that.state.planetId }
                                            }); // 传递状态
                                        }
                                    }
                                })
                            }
                        }
                    ]
                ],
                style: {
                    '--border-radius': '12px',
                    '--max-width': '280px',
                    '--adm-font-size-main': '16px'
                },
                bodyStyle: {
                    padding: 0
                },
                closeOnMaskClick: true,  // 新增这行，点击遮罩层可关闭
                closeOnAction: true     // 确保点击按钮后也关闭
            })
        }


        return (
            <div style={{ height: "100%", width: "100%", overflow: "auto" }}>
                <NavBar back='返回' onBack={() => {
                    this.props.navigate('/videos', { replace: true, state: { id: this.state.planetId } }); // 传递状态
                }}>
                    视频详情
                </NavBar>

                <div style={{ height: "94%" }}>

                    <div style={{ width: "94%", marginLeft: "3%", marginTop: "1%" }}>
                        <video
                            width="100%"
                            controls
                            src={this.state.videoInfo.fileUrl}
                            style={{ borderRadius: "2%" }}
                        >
                            Your browser does not support the video tag.
                        </video>


                        <div>
                            <div style={{ marginTop: "8px", width: "90%", marginLeft: "5%", borderBottom: "solid 2px #cdcdcd" }}>
                                <Grid columns={4}>
                                    <Grid.Item span={2}>
                                        <div style={{ marginLeft: "5px" }}>
                                            {dayjs(this.state.videoInfo.creationTime).format('YYYY年MM月DD日 HH点mm分')}
                                        </div>
                                    </Grid.Item>
                                    <Grid.Item span={2}>
                                        <div style={{ fontSize: "15px", textAlign: "end", lineHeight: "16px" }}>
                                            {
                                                this.state.videoInfo.creatorUserId == this.state.userInfo.id ?
                                                    <Space wrap>
                                                        {/* <Image src={"https://api.weibinyi.com/images/niannian/4/35-12.png"} fit='fill'
                                                            width={12} height={12} style={{ marginTop: "2px" }} onClick={() => {
                                                                this.props.navigate('/videoAdd', {
                                                                    replace: true, state: {
                                                                        planetId: this.state.planetId,
                                                                        id: this.state.videoInfo.id,
                                                                    }
                                                                }); // 传递状态
                                                            }} />
                                                        <span style={{ marginRight: "15px", fontSize: "12px" }} onClick={() => {
                                                            this.props.navigate('/videoAdd', {
                                                                replace: true, state: {
                                                                    planetId: this.state.planetId,
                                                                    id: this.state.videoInfo.id,
                                                                }
                                                            }); // 传递状态
                                                        }}>编辑</span> */}
                                                        <Image src={"https://api.weibinyi.com/images/niannian/4/35-13.png"} fit='fill'
                                                            width={12} height={12} style={{ marginTop: "2px" }} onClick={() => {
                                                                showDialog();
                                                            }} />
                                                        <span style={{ marginRight: "15px", fontSize: "12px" }} onClick={() => {
                                                            showDialog();
                                                        }}>删除</span>
                                                    </Space> : null
                                            }
                                        </div>
                                    </Grid.Item>
                                </Grid>
                            </div>
                        </div>
               
                    </div>

                    <div style={{ marginTop: "0px", paddingBottom: "80px" }}>
                        <List header=''>
                            {
                                this.state.userAction.map((item, index) => {
                                    return (<List.Item
                                        key={"1"}
                                        description={
                                            <>
                                                <Grid columns={6} gap={8}>
                                                    <Grid.Item span={1}>
                                                        <div style={{ marginRight: "10%", float: "right" }}>
                                                            <Image
                                                                src={item.headImg}
                                                                style={{ borderRadius: 20 }}
                                                                fit='cover'
                                                                width={40}
                                                                height={40}
                                                            />
                                                        </div>
                                                    </Grid.Item>
                                                    <Grid.Item span={5}>
                                                        <div style={{ fontWeight: "600", color: "#000" }}>
                                                            {item.creatorUserName}
                                                        </div>
                                                        <div style={{ fontWeight: "600", color: "#424242" }}>
                                                            {item.remark}
                                                        </div>
                                                        <div style={{ marginBottom: "10px", marginTop: "5px" }}>
                                                            <Grid columns={6} gap={8}>
                                                                <Grid.Item span={2}>
                                                                    {item.creationTime}
                                                                </Grid.Item>
                                                                <Grid.Item span={1}>
                                                                </Grid.Item>
                                                                <Grid.Item span={1}>
                                                                </Grid.Item>
                                                                <Grid.Item span={1}>
                                                                    <Image style={{ float: "left", marginTop: "3px" }}
                                                                        src={"https://api.weibinyi.com/images/niannian/1/1-18.png"}
                                                                        fit='fill' width={15} height={15}
                                                                        onClick={() => {
                                                                            this.setState({
                                                                                visible: true,
                                                                                textArea: "",
                                                                                pUserName: item.creatorUserName,
                                                                                pId: item.id,
                                                                            })
                                                                        }} />
                                                                    <span style={{ marginLeft: "5px" }}
                                                                        onClick={() => {
                                                                            this.setState({
                                                                                visible: true,
                                                                                textArea: "",
                                                                                pUserName: item.creatorUserName,
                                                                                pId: item.id,
                                                                            })
                                                                        }}>{item.yanCount}</span>
                                                                </Grid.Item>
                                                                <Grid.Item span={1}>
                                                                    <Image style={{ float: "left", marginTop: "3px" }}
                                                                        src={"https://api.weibinyi.com/images/niannian/1/1-20.png"}
                                                                        fit='fill' width={15} height={15} onClick={() => {
                                                                            var data = {
                                                                                TableId: this.state.id,
                                                                                Type: 2,
                                                                                TableType: "Media",
                                                                                UserActionId: item.id,
                                                                            };
                                                                            var model = item.yanList.filter(action =>
                                                                                action.creatorUserId === this.state.userInfo.id);
                                                                            if (model.length > 0) {
                                                                                return;
                                                                            }
                                                                            this.submitForm(data)
                                                                        }} />
                                                                    <span style={{ marginLeft: "5px" }} onClick={() => {
                                                                        var data = {
                                                                            TableId: this.state.id,
                                                                            Type: 2,
                                                                            TableType: "Media",
                                                                            UserActionId: item.id,
                                                                        };
                                                                        var model = item.yanList.filter(action =>
                                                                            action.creatorUserId === this.state.userInfo.id);
                                                                        if (model.length > 0) {
                                                                            return;
                                                                        }
                                                                        this.submitForm(data)
                                                                    }}>{item.zanCount}</span>
                                                                </Grid.Item>
                                                            </Grid>
                                                        </div>

                                                        <div>
                                                            {
                                                                item.cUserActionDto.map(item1 => {
                                                                    return (<>
                                                                        <Grid columns={6} gap={8}>
                                                                            <Grid.Item span={1}>
                                                                                <Image
                                                                                    src={environment.apiEndpoint + "/NNFiles/Img/" + item1.headImg}
                                                                                    style={{ borderRadius: 20 }}
                                                                                    fit='cover'
                                                                                    width={40}
                                                                                    height={40}
                                                                                />
                                                                            </Grid.Item>
                                                                            <Grid.Item span={5}>
                                                                                <div>
                                                                                    <span style={{ marginRight: "5px", color: "#000", fontWeight: "600" }}>
                                                                                        {item1.creatorUserName}
                                                                                    </span>
                                                                                    回复
                                                                                <span style={{ marginLeft: "5px", color: "#000", fontWeight: "600" }}>
                                                                                        {item1.userActionName}
                                                                                    </span>：
                                                                            </div>
                                                                                <span style={{ fontWeight: "600", color: "#424242" }}>
                                                                                    {item1.remark}
                                                                                </span>
                                                                            </Grid.Item>
                                                                        </Grid>
                                                                        <div style={{ marginBottom: "10px", marginTop: "5px" }}>
                                                                            <Grid columns={6} gap={8}>
                                                                                <Grid.Item span={1}>
                                                                                </Grid.Item>
                                                                                <Grid.Item span={2}>
                                                                                    {/* 2天前 */}
                                                                                    {this.formatTimeDifference(new Date(item1.creationTime))}
                                                                                </Grid.Item>
                                                                                <Grid.Item span={1}>
                                                                                </Grid.Item>
                                                                              
                                                                            </Grid>
                                                                        </div>
                                                                    </>)
                                                                })
                                                            }
                                                        </div>

                                                    </Grid.Item>
                                                </Grid>
                                            </>
                                        }
                                    >
                                    </List.Item>)
                                })
                            }

                        </List>

                        {
                            this.state.userAction.length == 0 ?
                                <div style={{
                                    textAlign: "center", fontSize: "20px", marginTop: "10%"
                                }}>
                                    暂无相关信息
                                </div>
                                : ""
                        }
                    </div>


                </div>


                <FloatingBubble
                    axis='xy'
                    magnetic='x'
                    style={{
                        '--initial-position-bottom': '22%',
                        '--initial-position-right': '24px',
                        '--edge-distance': '24px',
                        '--background': '#ffffff00',
                        '--size': '40px'
                    }}
                    onClick={() => {
                        this.setState({
                            visible: true,
                        })
                    }}
                >
                    <Image src={"https://api.weibinyi.com/images/niannian/1/1-15.png"} fit='fill' width={40} height={40} />
                </FloatingBubble>

                <Popup
                    visible={this.state.visible}
                    onMaskClick={() => {
                        this.setState({
                            visible: false,
                        })

                    }}
                    bodyStyle={{
                        borderTopLeftRadius: '18px',
                        borderTopRightRadius: '18px',
                        minHeight: '40vh',
                    }}
                >
                    <div style={{
                        backgroundImage: this.state.titleTab == 0 ?
                            "url('https://api.weibinyi.com/images/niannian/3/5-9-25.png')" : ""
                        , backgroundRepeat: "no-repeat", backgroundSize: "100% 100%", minHeight: "40vh"
                    }}>
                        
                        <div className="liuyan" style={{ width: "94%", marginLeft: "3%" }}>
                            <div style={{
                                marginTop: "20px", fontSize: "16px", marginLeft: "5px", fontWeight: "600", marginBottom: "13px"
                            }}>
                                请输入您的留言信息：
                                </div>

                            <div>
                                <TextArea placeholder={this.state.pUserName == ""
                                    ? "请输入您的留言信息" : ('回复：' + this.state.pUserName)}
                                    defaultValue={this.state.textArea}
                                    maxLength={500} rows={6} showCount value={this.state.textArea}
                                    style={{
                                        border: 'solid 1px #c7c7c7', marginTop: '5px', borderRadius: '3%',
                                        marginBottom: '5px', padding: "10px"
                                    }} onChange={(e) => {
                                        this.setState({
                                            textArea: e
                                        })
                                    }}
                                />
                            </div>

                            <div style={{
                                backgroundImage: "url('https://api.weibinyi.com/images/niannian/4/46-10.png')"
                                , backgroundRepeat: "no-repeat", backgroundSize: "100% 100%", height: "38px"
                                , marginLeft: "10%", width: "80%", textAlign: "center", fontSize: "17px", lineHeight: "38px"
                                , fontWeight: "600", color: "#fff", marginTop: "15px"
                            }} onClick={() => {
                                var data = {
                                    TableId: this.state.id,
                                    Type: 1,
                                    Remark: this.state.textArea,
                                    TableType: "Media",
                                    UserActionId: this.state.pId,
                                };
                                this.submitForm(data)
                            }}>
                                提 交
                            </div>

                        </div>
                    </div>
                </Popup>


                <BottomMenu selectKey="home" position="absolute" />

            </div>
        )
    }
}

export default withNavigate(Index);